import Bugsnag from '@bugsnag/js'
import BugsnagPerformance from '@bugsnag/browser-performance'

if (window.bugsnagConfig?.apiKey) {
  const apiKey = window.bugsnagConfig.apiKey
  const releaseStage = window.bugsnagConfig.releaseStage
  const appVersion = window.bugsnagConfig.appVersion

  Bugsnag.start({
    apiKey: apiKey,
    releaseStage: releaseStage,
    appVersion: appVersion,
    user: window.bugsnagConfig.currentUser
  })

  BugsnagPerformance.start({
    apiKey: apiKey,
    appVersion: releaseStage,
    releaseStage: appVersion
  })
}
